require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/angular-sanitize/index.js
// module id = 142
// module chunks = 0